import type { UseFetchOptions } from '#app'
import { createList } from '~/utils'
import { ERRORS } from '~/types/errors'
import merge from 'lodash.merge'

export function useAuthFetch(request, opts?, fixSSR = false) {
  const { $toast, $i18n } = useNuxtApp()
  const config = useRuntimeConfig()
  const { accessToken } = storeToRefs(useAuthStore())
  const { t: $t } = $i18n

  const defaultOptions: UseFetchOptions<any> = {
    baseURL: String(config.public.API_BASE_URL),
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Authorization': `Bearer ${accessToken.value}`,
    },
    server: false,
    onRequestError: ({ request, options, error }) => {
      console.log(error)
      $toast.error(error.message)
    },
    onResponseError: ({ response, error }) => {
      if (
        response._data.errorCode === ERRORS.UNAUTHORIZED_ERROR ||
         [401, 403, 440, 419].includes(response.status) ||
        response._data.error === ERRORS.USER_UNAUTHORIZED
      ) {
        const { logoutUser } = useAuthStore()
        logoutUser()
      }
      console.log(response._data)
      if (response._data.errorCode === ERRORS.VALIDATION_ERROR) {
        const validationMessagesList = response._data.message.map(
          e => `- ${e.error}`
        )

        $toast.error(
          $t('FORM_ERRORS.VALIDATION_ERROR', {
            errorList: validationMessagesList.join('\n'),
          })
        )
      } else {
        $toast.error(response._data.message)
      }
    },
    deduplication: false
  }
  const options: any = merge({}, defaultOptions, opts);
  if (fixSSR) {
    return $fetch(request, options)
  } else {
    return useFetch(request, options)
  }
}
